module.exports = __webpack_public_path__ + "img/7ce4007.png";